import { graphql } from 'gatsby';
import React from 'react';
import News from '../pageComponents/News';

export default function NewsArchive({ ...props }) {
  return <News {...props} />;
}

export const query = graphql`
  fragment Thumbnail on File {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }

  query NewsPage {
    allWpNew {
      nodes {
        id
        uri
        slug
        dateGmt(formatString: "MMMM DD, YYYY")
        title
        excerpt
        featuredImage {
          node {
            localFile {
              ...Thumbnail
            }
          }
        }
      }
    }
  }
`;
